import React, { PureComponent } from 'react';

import { Loading } from 'components/cosmos';
import {
  ASYNC_IMAGE_INTERVAL,
  ASYNC_IMAGE_MAX_TRIALS,
  VALID_FILE_REQUEST_STATUS
} from 'modules/file/constants';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import './AsyncImage.scss';

class AsyncImage extends PureComponent {
  static propTypes = {
    url: PropTypes.string,
    className: PropTypes.string,
    onError: PropTypes.func,
    onLoad: PropTypes.func,
    isThumbnailLoading: PropTypes.bool,
    onStopLoading: PropTypes.func
  };

  state = {
    loading: false,
    hasError: false
  };

  trials = 0;
  setError = () => {
    const { onError, onStopLoading } = this.props;

    if (onError) {
      this.setState({ loading: false });
      onStopLoading();
      onError();

      return;
    }

    UiService.setAlertError('error_try_again');
    this.setState({ hasError: true, loading: false });
    onStopLoading();
  };

  fetchImage = async () => {
    const { url } = this.props;

    if (this.trials >= ASYNC_IMAGE_MAX_TRIALS) {
      this.setError();
      return;
    }

    this.trials++;
    this.setState({ loading: true });

    try {
      const response = await fetch(url);

      if (VALID_FILE_REQUEST_STATUS.includes(response.status)) {
        this.setState({ loading: false, hasError: false });
        this.props.onStopLoading();
      }
    } catch {
      if (this.trials < ASYNC_IMAGE_MAX_TRIALS) {
        setTimeout(this.fetchImage, ASYNC_IMAGE_INTERVAL);
        return;
      }
      this.setError();
    }
  };

  handleLoadError = () => {
    this.trials = 0;
    this.fetchImage();
  };

  get renderContent() {
    const { url, onLoad, isThumbnailLoading } = this.props;
    const { loading, hasError } = this.state;

    if (isThumbnailLoading || loading) {
      return <Loading center />;
    }

    if (hasError) {
      return <i className="asyncImage__error icon icon-check-red-big" />;
    }

    return (
      <img
        className="asyncImage__img"
        src={url}
        onLoad={onLoad}
        onError={this.handleLoadError}
      />
    );
  }

  render() {
    const { className } = this.props;

    return <div className={className}>{this.renderContent}</div>;
  }
}

export default AsyncImage;
